import type {
  HomeBatteryFunnelSettingsInterface,
  HomeBatteryFunnelStep,
} from '@innogy/feh/models';
import { createNamedFunnelActions } from '@innogy/feh/shared';
import type { GenericProductData } from '@legacy/common-ui-models';

const feature = 'HomeBattery';

export const {
  initializeHomeBatteryFunnelStepAction,
  setHomeBatteryFunnelInitializedAction,
  clearHomeBatteryFunnelInitializedAction,
  onHomeBatteryFunnelNavigationAction,
  handleHomeBatteryFunnelPrivateErrorAction,
  handleHomeBatteryFunnelGenericErrorAction,
  toggleHomeBatteryProductSelectionAction,
  confirmHomeBatteryProductSelectionAction,
  resetHomeBatteryProductSelectionAction,
  selectHomeBatteryProductsAction,
  mintHomeBatteryTrackingIdAction,
} = createNamedFunnelActions<
  typeof feature,
  HomeBatteryFunnelStep,
  HomeBatteryFunnelSettingsInterface,
  GenericProductData
>(feature);
